import { Component, Input, inject } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { AutoCompleteFilterComponent } from '../autocomplete-filter/autocomplete-filter.component';
import { FilterTypeComponent } from "../filter-type/filter-type.component";
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-result-filter',
    templateUrl: './result-filter.component.html',
    styleUrls: ['./result-filter.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        AutoCompleteFilterComponent,
        CommonModule,
        OverlayModule,
        FilterTypeComponent,
        TranslateDirective, TranslatePipe
    ]
})

export class ResultFilterComponent {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore)

  readonly filterList$ = this.#manipulationsToolbarStore.filterList$
  isFilterListOpen$=toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  constructor(
  ) {
  }
}
